import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | timeout
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get("session_id");
    if (!sid) { setState("timeout"); return; }
    let active = true;
    const poll = async (n) => {
      if (!active) return;
      if (n > 8) { setState("timeout"); return; }
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") { setState("paid"); return; }
      } catch { /* ignore */ }
      setTries(n);
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
    return () => { active = false; };
  }, []);

  return (
    <div className="min-h-[80vh] bg-[#fff7f0] flex items-center justify-center px-6 text-center">
      <div className="max-w-sm">
        {state === "checking" && (<><Loader2 className="h-12 w-12 animate-spin text-[#ff6b5b] mx-auto" /><p className="mt-4 text-slate-600">Confirming your payment…</p></>)}
        {state === "paid" && (<>
          <CheckCircle2 className="h-16 w-16 text-[#22c55e] mx-auto" />
          <h1 className="mt-4 font-display text-3xl font-extrabold text-slate-900">You're Premium! 🎉</h1>
          <p className="mt-2 text-slate-500">Unlimited chats unlocked. Go find your dream home.</p>
          <Button onClick={() => navigate("/discover")} className="mt-6 rounded-full bg-[#ff6b5b] hover:bg-[#f2523f] text-white px-8 h-12">Keep swiping</Button>
        </>)}
        {state === "timeout" && (<>
          <p className="text-slate-600">Still processing. If you were charged, your Premium will activate shortly.</p>
          <Button onClick={() => navigate("/premium")} className="mt-5 rounded-full bg-[#ff6b5b] text-white">Back to Premium</Button>
        </>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[80vh] bg-[#fff7f0] flex items-center justify-center px-6 text-center">
      <div className="max-w-sm">
        <XCircle className="h-16 w-16 text-slate-300 mx-auto" />
        <h1 className="mt-4 font-display text-2xl font-bold text-slate-900">Payment cancelled</h1>
        <p className="mt-2 text-slate-500">No worries — your free trial is still on. You can subscribe anytime.</p>
        <Button onClick={() => navigate("/premium")} className="mt-6 rounded-full bg-[#ff6b5b] hover:bg-[#f2523f] text-white">Back to Premium</Button>
      </div>
    </div>
  );
}
